var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-level"},[_c('div',{staticClass:"text-h3 soon-to-come"},[_vm._v("Soon to come...")])])}]

export { render, staticRenderFns }